<!--<ul class="breadcrumb bg-transparent fg-white my-0">-->
<!--   <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbSrv.breadcrumbs">-->

<!--      <a *ngIf="breadcrumb.url"-->
<!--         [routerLink]="breadcrumb.url"-->
<!--         routerLinkActive="active"-->
<!--         [innerHTML]="toHtml(breadcrumb.label)">-->
<!--      </a>-->

<!--      <span *ngIf="!breadcrumb.url" [innerHTML]="toHtml(breadcrumb.label)"-->
<!--            style="padding-left: 0;padding-right: 5px;"></span>-->

<!--   </li>-->
<!--</ul>-->

<!--esempio bootstrap 5-->
<!--<nav aria-label="breadcrumb">-->
<!--   <ol class="breadcrumb">-->
<!--      <li class="breadcrumb-item"><a href="#">Home</a></li>-->
<!--      <li class="breadcrumb-item active" aria-current="page">Library</li>-->
<!--   </ol>-->
<!--</nav>-->


<nav class="flex" aria-label="Breadcrumb">
   <ol>
<!--      <li class="inline-flex items-center">-->
<!--         <a [routerLink]="'/admin/dashboard'">-->
<!--            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"-->
<!--                 xmlns="http://www.w3.org/2000/svg"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>-->
<!--            </svg>-->
<!--            Home-->
<!--         </a>-->
<!--      </li>-->
      <li *ngFor="let breadcrumb of breadcrumbSrv.breadcrumbs; let first = first;">
         <div *ngIf="breadcrumb.url" class="flex items-center" >

            <svg *ngIf="first" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"
                 xmlns="http://www.w3.org/2000/svg"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
            </svg>

            <svg *ngIf="!first" class="w-6 h-6 text-gray-400" fill="currentColor"
                 viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
            <a [routerLink]="breadcrumb.url">{{breadcrumb.label}}</a>
         </div>
         <div *ngIf="!breadcrumb.url" class="flex items-center">
            <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
            <span>{{breadcrumb.label}}</span>
         </div>
      </li>
   </ol>
</nav>
